import { render, staticRenderFns } from "./Ebookdetail.vue?vue&type=template&id=d745448c&"
import script from "./Ebookdetail.vue?vue&type=script&lang=js&"
export * from "./Ebookdetail.vue?vue&type=script&lang=js&"
import style0 from "./Ebookdetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports